module.exports = __webpack_public_path__ + "img/286.5efe5b1f.png";